import { motion } from "framer-motion"

const Loader = (props) => {
    
    return (
        <motion.section 
            className="hero is-fullheight is-black pt-4 pl-4 pb-4 pr-4 is-fixed"
            {...props.framer.fade}
        >
            <div className="hero-head">
            </div>
            <div className="hero-body">
                <div className="container has-text-centered">           
                    <img className="image logo" alt="" src={"./img/logo_white.svg"} />  
                    <p className="dloader mt-6"></p>        
                </div>
            </div>
            <div className="hero-foot">
            </div>
        </motion.section>
    )
}
export default Loader;



